import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../shared/api.service';
import { AuthenticationService } from '../shared/authentication.service';
import { LicenseService } from '../shared/licens.service';
import { SubsciptionData, LicenseData } from '../models/LicenseData';
import { Common } from '../shared/common';
import { LineupOptions, PAP } from './pap-dto/pap-dto';
import { saveAs } from 'file-saver';
import { Union } from '../models/Union';
import { DraftForm, ElectionStepLogForm, Poll, ReceivedDraft } from '../models/Poll';
import { CollegeCandidatesData } from './cse-poll-creation/poll-creation-union/poll-creation-union.component';
import { Voter } from '../models/Voter';

import { v4 } from 'uuid';
import { ImageTypes } from 'src/app/models/Enums';
import { LiveQuestion } from '../models/PollChoice';
import { ListQuestion, PollCreationData, PollQuestion } from '../models/PollCreationData';
import { HttpErrorResponse } from '@angular/common/http';
import { Assessor } from '../models/Assessor';
import { AssessorTestResult, ReceivedPoll } from '../models/ReceivedPoll';
import { ShortVoter } from '../models/ShortVoter';
import { AssessorData } from '../models/AssessorData';
import { ChangeVoterForm } from '../models/PaymentData';

@Component({
  selector: 'app-pap-creation',
  templateUrl: 'pap-creation.component.html',
  styleUrls: ['./pap-creation.component.less', '../shared/common.less'],
})

export class PapCreationComponent implements OnInit {
  // Data about the user on ngOnInit
  accountName: string = "";
  maxVoters = 5;
  sms = '';
  licenseTime: string = "";
  newLicences: Array<SubsciptionData> = [];
  clientType = 'assoc';
  language = 'fr';
  // variables for popup
  shouldBuyCredits = false;
  shouldDisplayPopup = false;
  hasSmsVoters = false;
  shouldDisplayNewLicences = false;
  shoulDisplayChangePopup = false;
  smsAdditionalOption = false;
  moreOption = false;
  selectedOffer: number;
  isAssoc = true;
  getContacted = false;
  confirmContact = false;
  licencesReady = false;
  editionDonePopup: boolean = false;
  remainingLicense: number;
  hotlinePopup = false;
  hasHotline = false;
  displayHotline = false;
  hotlineConfirmation = false;
  prePolToast: boolean = false;
  papPopup: boolean = false;

  papValues: PAP = {
    title: '',
    venue: {
      legalName: '',
      legalForm: '',
      capital: '',
      rcs: '',
      address: '',
      siret: '',
      zipcode: '',
      city: '',
      idcc: ''
    },
    informations: {
      partial: false,
      duration: [],
      colleges: 1,
      date: new Date()
    },
    context: {
      cancelled: false,
      cancellationDate: new Date(),
      setup: true,
      expirationDate: new Date(),
      noQuorum: true,
      previousElectionId: ''
    },
    previous: {
      previousElectionDate: null,
      hasSameSiret: false,
      siret: ''
    },
    sirets: {
      sirets: []
    },
    colleges: [{
      collegeType: [],
      collegeName: '',
      genderDistribution: [0, 0],
      seats: 0,
      lineup: 0,
      substituteSeats: 0,
      composition: [],
      proportion: [0, 0],
      substituteProportion: [0, 0],
      detail: '',
      cancelledElection: new Date()
    }],
    period: {
      fROpening: new Date(new Date().setDate(new Date().getDate() + 14)),
      fRClosing: new Date(new Date().setDate(new Date().getDate() + 21)),
      sROpening: new Date(new Date().setDate(new Date().getDate() + 28)),
      sRClosing: new Date(new Date().setDate(new Date().getDate() + 35))
    },
    contact: {
      name: '',
      firstName: '',
      occupation: '',
      mail: '',
      phone: ''
    },
    employer: {
      man: true,
      name: '',
      firstName: '',
      role: ''
    },
    unions: [{
      man: true,
      unionName: '',
      firstName: '',
      lastName: '',
      role: ''
    }],
    termLength: {
      partial: false,
      duration: [0, 0]
    },
    headcount: {
      total: 0,
      fullMembers: 0,
      numberOfColleges: 1
    },
    application: {
      mailOption: false,
      address: '',
      zip: '',
      city: '',
      emailOption: false,
      emailAddress: '',
      handOption: false,
      firstName: '',
      lastName: '',
      firstRoundLimit: new Date(new Date().setDate(new Date().getDate() + 7)),
      secondRoundLimit: new Date(new Date().setDate(new Date().getDate() + 21))
    },
    electionYear: new Date().getFullYear(),
    commonLists: [],
    round: {
      firstRound: true,
      shortage: true
    },
    draftId: ''
  };
  papCreationStep: boolean = true;
  papVerificationStep: boolean = false;
  papCompletedStep: boolean = false;
  cerfaCreationStep: boolean = false;
  cerfaVerificationStep: boolean = false;
  cerfaCompletedStep: boolean = false;
  pollCreationStep: boolean = false;
  assessorClosingStep: boolean = false;
  assessorStep = 1;

  papVerificationReady: boolean = false;
  cerfaVerificationReady: boolean = false;

  expandedView: boolean[] = [true, false, false, false, false, false, false, false, false];
  verifiedComponents: boolean[] = [false, false, false, false, false, false, false, false, false];
  componentValidated: boolean = false;
  verificationPercentage: number = 0;
  cerfaExpandedView: boolean[] = [true, false, false, false, false];
  cerfaVerifiedComponents: boolean[] = [false, false, false, false, false];
  cerfaVerificationPercentage: number = 0;
  cerfaComponentValidated: boolean = false;
  currentStep: number = 1;
  step = 1;
  stepOneDone = false
  stepTwoDone = false
  votersListReady = false;
  unions: Array<Union> = [];
  areAssessorsValidated: boolean = false;
  collegeCandidatesData: Array<CollegeCandidatesData> = [];
  validatedColleges: Set<number> = new Set();
  isLoading = false;
  isLaunching = false;
  isError = false;
  errorMessage: string = "";
  errorDescription: string = "";
  votersConfirmed: boolean = false;
  currentPoll: Poll = this.createWatchedPoll(new Poll());
  pollCreationLoader: boolean = false;
  assessorsInvitesLoader: boolean = false;
  remainingAssessors = 0;
  assessorTestQuorum: AssessorTestResult = new AssessorTestResult(0, 0, 0);
  inactiveAssessors: ShortVoter[] = [];
  isTestVoteOpen: boolean = false;
  closingAssessorsVoteLoader: boolean = false
  unsealStepReady: boolean = false;
  unsealedAssessors: Array<AssessorData> = [];
  isBallotUnsealed: boolean = false;
  testStepStatus: string = "";
  pollReadyStep: boolean = false;
  pollId: string = "";
  displayChangeAssessor: boolean = false;
  mailToChange: string = "";
  displayResendAssessor: boolean = false;
  assessorToRelaunch: string = "";

  private createWatchedPoll(poll: Poll): Poll {
    return new Proxy(poll, {
      set: (target, prop, value) => {
        target[prop] = value;
        setTimeout(() => this.onCurrentPollChange());
        return true;
      }
    });
  }

  updateAssessor(mail: string) {
    this.displayChangeAssessor = true;
    this.mailToChange = mail;
  }

  relaunchAssessor(mail: string) {
    this.displayResendAssessor = true;
    this.assessorToRelaunch = mail;

  }

  launchAssessorsRelaunch($event: boolean) {
    this.displayResendAssessor = false
    const form = new ChangeVoterForm(this.assessorToRelaunch, this.assessorToRelaunch, this.common.getLangCode());

    this.assessorToRelaunch = "";
    if ($event) {
      this.apiService.changeAssessor(form, this.pollId).subscribe(res => {
      }, error => {
        console.log(error);
      });
    }
  }

  accessorValidated() {
    this.areAssessorsValidated = true;

    // Récupérer les données des assesseurs
    if (this.currentPoll.assessors && this.currentPoll.assessors.length > 0) {
      this.currentPoll.assessorsMails = this.currentPoll.assessors.map(assessor => assessor.email);
      this.currentPoll.assessorsNames = this.currentPoll.assessors.map(assessor => assessor.name);
    }

    this.displayCandidatesData();
  }

  onCollegeCandidatesDataReceived(event: Array<CollegeCandidatesData>) {
    this.collegeCandidatesData = event;
  }

  voterToString(voter: Voter) {
    const base = `${voter.firstName} ${voter.lastName}`;
    if (voter.gender === 'H') {
      return `M. ${base}`;
    } else { return `Mme ${base}`; }
  }

  displayCandidatesData() {
    // Titulaires
    this.collegeCandidatesData.forEach((college: CollegeCandidatesData) => {
      let list: LiveQuestion = {} as LiveQuestion;
      college.data.forEach((unionData) => {
        const cand = unionData.titularCandidates.map((c: Voter) => this.voterToString(c));
        const candidates = unionData.titularCandidates
          .map((c: Voter) => `${c.firstName} ${c.lastName} ${c.email}`)
          .join(', ');
        list = new LiveQuestion(college.collegeIndex, cand, unionData.union.shortName, 0, 1, 1, "Titulaire", unionData.union.file, [unionData.union.logo], college.collegeIndex, true);
        this.currentPoll.liveQuestions.push(list);
      });
    });

    // Suppléants
    this.collegeCandidatesData.forEach((college: CollegeCandidatesData) => {
      let list: LiveQuestion = {} as LiveQuestion;
      college.data.forEach((unionData) => {
        const cand = unionData.substituteCandidates.map((c: Voter) => this.voterToString(c));
        const candidates = unionData.substituteCandidates
          .map((c: Voter) => `${c.firstName} ${c.lastName} ${c.email}`)
          .join(', ');
        list = new LiveQuestion(college.collegeIndex, cand, unionData.union.shortName, 0, 1, 1, "Suppléant", unionData.union.file, [unionData.union.logo], college.collegeIndex, false);
        this.currentPoll.liveQuestions.push(list);
      });
    });

  }

  onCurrentPollChange() {
    this.stepTwoDone = this.secondStepCompleted();
  }

  constructor(
    public auth: AuthenticationService,
    private router: Router,
    private apiService: ApiService,
    private route: ActivatedRoute,
    public licenseService: LicenseService,
    private common: Common
  ) { }

  votersReady() {
    this.votersListReady = true;
    this.apiService.insertEventLog(this.currentPoll.id, new ElectionStepLogForm('Validation', 'voters')).subscribe((res) => {
      // console.log(res);
    });
  }

  goToNextCreationStep() {
    if (this.step === 1) {
      this.papValues.draftId = this.currentPoll.id;
      this.apiService.updateCseCollegeData(this.papValues).subscribe(res => { });
    }
    if (this.currentPoll.id != null) {
      this.currentPoll.votingType = 'list';
      const data: DraftForm = new DraftForm().fromPoll(this.currentPoll, this.papValues);
      if (this.currentPoll.draftSaved) {
        this.apiService.updateDraft(data).subscribe(res => { });
      } else {
        this.apiService.saveDraft(data).subscribe(res => { this.currentPoll.draftSaved = true; });
      }
    }
    this.step++;
  }

  goToPreviousCreationStep() {
    this.step--;
  }

  updateCurrentStep() {
    if (this.papCreationStep || this.papVerificationStep || this.papCompletedStep) {
      this.currentStep = 1;
    }
    else if (this.cerfaCreationStep || this.cerfaVerificationStep || this.cerfaCompletedStep) {
      this.currentStep = 2;
    } else {
      this.currentStep = 3;
    }
  }

  saveUnionImage($event) {
  }

  handleElectionImage(event: { imageBlob: Blob, extensionImage: string }) {
    this.uploadImage(event.imageBlob, event.extensionImage, ImageTypes.Poll);
  }

  setImageUrlToLocation(url: string, destination: ImageTypes, index = 0, list = 0) {
    switch (destination) {
      case ImageTypes.Poll: {

        this.currentPoll.imageId = url;
        break;
      }
      case ImageTypes.List: {
        this.unions[index].logo = url;
        //        this.currentPoll.liveQuestions[index].listImage = [url];
      }
    }
  }

  uploadImage(image: Blob, ext: string, destination: ImageTypes, index = 0, candidateIndex = 0) {
    const pollPayload = new FormData();
    const name = v4() + ext;
    pollPayload.append(name, image);
    //this.isLoading = true;
    this.apiService.saveElectionImage(this.currentPoll.id, pollPayload).subscribe((res) => {
      //this.isLoading = false;
      this.apiService.getElectionImageUrl(res[0]);
      this.setImageUrlToLocation(this.apiService.getElectionImageUrl(res[0]), destination, index, candidateIndex);
      //this.markPollChanges();
    });
  }

  createPoll() {
    const questions: Array<ListQuestion> = [];
    const configuredQuestions = this.configureListElection(questions);
    this.setupVoters();
    const pollData = this.createPollData(configuredQuestions);
    pollData.isLive = false;
    this.sendPoll(pollData);
  }

  configureListElection(questions: Array<ListQuestion>): Array<ListQuestion> {
    let candidatesByCollege = this.currentPoll.liveQuestions.reduce((acc, question) => {
      const collegeIndex = question.college;
      if (!acc[collegeIndex]) {
        acc[collegeIndex] = [];
      }
      acc[collegeIndex].push(question);
      return acc;
    }, {} as { [key: number]: Array<LiveQuestion> });

    Object.keys(candidatesByCollege).forEach(collegeKey => {
      const collegeIndex = parseInt(collegeKey);
      const questionsOfThisCollege = candidatesByCollege[collegeIndex];
      const titulaires = questionsOfThisCollege.filter(q => q.mainElection === true);
      const suppleants = questionsOfThisCollege.filter(q => q.mainElection === false);

      if (titulaires.length > 0) {
        const titulairesPollQuestions: Array<PollQuestion> = titulaires.map(liveQ => {

          // Trouver l'union correspondante et récupérer son logo
          const union = this.unions.find(u => u.shortName === liveQ.title);
          const listImage = union && union.logo ? [union.logo] : (liveQ.listImage || []);

          return new PollQuestion(
            liveQ.title,
            liveQ.options || [],
            liveQ.numberOfVote || 1,
            [],
            liveQ.listLink || '',
            listImage,
            []
          );
        });

        questions.push(new ListQuestion(
          titulaires[0].electionTitle || 'Titulaire',
          titulairesPollQuestions,
          collegeIndex,
          true
        ));
      }

      if (suppleants.length > 0) {
        const suppleantsPollQuestions: Array<PollQuestion> = suppleants.map(liveQ => {
          // Trouver l'union correspondante et récupérer son logo
          const union = this.unions.find(u => u.shortName === liveQ.title);
          const listImage = union && union.logo ? [union.logo] : (liveQ.listImage || []);

          return new PollQuestion(
            liveQ.title,
            liveQ.options || [],
            liveQ.numberOfVote || 1,
            [],
            liveQ.listLink || '',
            listImage,
            []
          );
        });

        questions.push(new ListQuestion(
          suppleants[0].electionTitle || 'Suppléant',
          suppleantsPollQuestions,
          collegeIndex,
          false
        ));
      }
    });

    return questions;
  }

  setupVoters() {
    if (!this.needsSms()) {
      this.currentPoll.voters = this.currentPoll.voters.map(voter =>
        new Voter(voter.firstName, voter.lastName, voter.email, voter.weight, undefined, voter.validationCode, voter.language, voter.college)
      );
    }
    this.currentPoll.voters = this.currentPoll.voters.filter(x => x.email.length > 0);
  }

  needsSms(): boolean {
    return this.currentPoll.isSMS || this.currentPoll.is2FA;
  }

  createPollData(questions: Array<ListQuestion>): PollCreationData {
    return new PollCreationData(
      this.currentPoll.title,
      this.currentPoll.voters,
      this.currentPoll.description,
      questions,
      this.getStartDate(),
      this.getEndDate(),
      this.currentPoll.imageId,
      'list', // votingType is always 'list' for CSE elections
      this.currentPoll.isUncrypted,
      this.currentPoll.isSMS,
      this.currentPoll.numberOfVote,
      this.currentPoll.is2FA,
      this.currentPoll.sender,
      this.currentPoll.sharedLinks,
      this.hasHotline,
      this.common.getLangCode(),
      this.currentPoll.id,
      this.currentPoll.password,
      this.currentPoll.phoneChangeable,
      this.currentPoll.welcomeText,
      this.currentPoll.quorum,
      this.getInviteDate(),
      this.getConvocationDate(),
      this.currentPoll.ignoreAbstentions
    );
  }

  getStartDate(): number {
    // Utiliser papValues.period.fROpening si currentPoll.startDate n'est pas défini
    if (!this.currentPoll.startDate || this.currentPoll.startDate === '' || this.currentPoll.startDate === undefined) {
      if (this.papValues.period.fROpening) {
        return new Date(this.papValues.period.fROpening).getTime();
      }
    }

    if (this.common.checkIfSafari()) {
      const dateParts = this.currentPoll.startDate.split('/');
      if (dateParts.length === 1) {
        return new Date(
          this.currentPoll.startDate + 'T' + this.currentPoll.startTime
        ).getTime();
      } else {
        this.currentPoll.startDate =
          dateParts[1] + '/' + dateParts[0] + '/' + dateParts[2];
      }
    }

    const timestamp = new Date(`${this.currentPoll.startDate} ${this.currentPoll.startTime}`).getTime();

    // Si le résultat est NaN, utiliser papValues.period.fROpening
    if (isNaN(timestamp) && this.papValues.period.fROpening) {
      return new Date(this.papValues.period.fROpening).getTime();
    }

    return timestamp;
  }

  getEndDate(): number {
    // Utiliser papValues.period.fRClosing si currentPoll.endDate n'est pas défini
    if (!this.currentPoll.endDate || this.currentPoll.endDate === '' || this.currentPoll.endDate === undefined) {
      if (this.papValues.period.fRClosing) {
        return new Date(this.papValues.period.fRClosing).getTime();
      }
    }

    if (this.common.checkIfSafari()) {
      const dateParts = this.currentPoll.endDate.split('/');
      if (dateParts.length === 1) {
        return new Date(
          this.currentPoll.endDate + 'T' + this.currentPoll.endTime
        ).getTime();
      } else {
        this.currentPoll.endDate =
          dateParts[1] + '/' + dateParts[0] + '/' + dateParts[2];
      }
    }

    const timestamp = new Date(
      this.currentPoll.endDate + ' ' + this.currentPoll.endTime
    ).getTime();

    // Si le résultat est NaN, utiliser papValues.period.fRClosing
    if (isNaN(timestamp) && this.papValues.period.fRClosing) {
      return new Date(this.papValues.period.fRClosing).getTime();
    }

    return timestamp;
  }

  getInviteDate(): number {
    if (this.currentPoll.inviteDate !== null && this.currentPoll.inviteTime !== null) {
      return new Date(this.currentPoll.inviteDate + ' ' + this.currentPoll.inviteTime).getTime();
    } else {
      return null;
    }
  }

  getConvocationDate(): number {
    if (this.currentPoll.convocationDate !== null && this.currentPoll.convocationTime !== null) {
      return new Date(this.currentPoll.convocationDate + ' ' + this.currentPoll.convocationTime).getTime();
    } else {
      return null;
    }
  }

  setAssessorsObject() {
    this.currentPoll.assessors = [];
    for (let i = 0; i < this.currentPoll.assessorsMails.length; i++) {
      if (this.currentPoll.assessorsNames[i] && this.currentPoll.assessorsNames[i].length > 0 &&
        this.currentPoll.assessorsMails[i] && this.currentPoll.assessorsMails[i].length > 0) {
        this.currentPoll.assessors.push(
          new Assessor(this.currentPoll.assessorsNames[i], this.currentPoll.assessorsMails[i])
        );
      }
    }
  }

  sendPoll(data: PollCreationData) {
    if (
      (data.description == null ||
        data.name == null ||
        data.questions.length === 0 ||
        data.voters.length < 1 ||
        isNaN(data.startDate) ||
        isNaN(data.endDate))
    ) {
      this.isError = true;
      this.errorMessage = 'Ce scrutin ne peut être lancé car certains éléments sont manquants ou incorrects';
      this.errorDescription = 'Veuillez vérifier que tous les champs obligatoires sont remplis';
    } else {
      if (!this.isLaunching) {
        if (data.sender === undefined) {
          data.sender = '';
        }
        if (data.sharedLinks == undefined || data.sharedLinks.length === 0) {
          data.sharedLinks = undefined;
        }
        this.currentPoll.isAssessors = true;
        if (this.currentPoll.isAssessors && this.areAssessorsValidated) {
          this.setAssessorsObject();
          data.assessors = this.currentPoll.assessors;
        }
        const jsonObj = JSON.stringify(data);
        this.isLaunching = true;
        this.isLoading = true;
        // console.log(this.unions);
        this.apiService.saveUnions(this.papValues.draftId, this.unions).subscribe(res => {
          this.postPoll(jsonObj);
        });
      }
    }
  }

  postPoll(jsonObj: string) {
    this.pollCreationLoader = true;
    this.apiService.createPoll(jsonObj).subscribe(
      (res: any) => {
        const id = res.id;
        this.isLoading = false;
        this.isLaunching = false;
        this.pollCreationLoader = false;
        // Navigate to the planned poll view
        this.router.navigate(['/pap-creation'], { queryParams: { draft: id } });
        this.pollCreationStep = false;
        this.assessorClosingStep = true;
      },
      (err: HttpErrorResponse) => {
        this.pollCreationLoader = false;
        this.isLoading = false;
        this.isLaunching = false;
        this.isError = true;
        this.errorMessage = 'Une erreur est survenue lors de la création du scrutin';
        this.errorDescription = err.error?.message || err.message;
        console.error('Error creating poll:', err);
      }
    );
  }

  logDetails() {
    // console.log(this.papValues);
    // console.log(this.currentPoll);
    // console.log(this.unions);
    console.log(this.collegeCandidatesData);


  }

  firstStepCompleted(): boolean {
    // 1. Si premier tour et pas en setup, vérifier que expirationDate est définie

    if (this.papValues.round.firstRound === true && this.papValues.context.setup === false) {
      if (!this.papValues.context.expirationDate) {
        return false;
      }
    }

    // 2. Vérification du headcount
    const headcount = this.papValues.headcount;
    if (headcount.total <= 0) return false;
    if (headcount.fullMembers <= 0 || headcount.fullMembers >= headcount.total) return false;
    if (headcount.numberOfColleges <= 0 || headcount.numberOfColleges >= 5) return false;

    // 3. Vérifier que la somme des lineup ne dépasse pas headcount.total
    const totalLineup = this.papValues.colleges.reduce((sum, college) => sum + (college.lineup || 0), 0);
    if (totalLineup !== headcount.total) return false;

    // 3.1. Vérifier que la somme des seats et des substituteSeats ne dépasse pas headcount.fullMembers
    const totalSeats = this.papValues.colleges.reduce((sum, college) => sum + (college.seats || 0), 0);
    const totalSubstituteSeats = this.papValues.colleges.reduce((sum, college) => sum + (college.substituteSeats || 0), 0);
    if (totalSeats != headcount.fullMembers || totalSubstituteSeats > headcount.fullMembers) return false;

    // 4. Vérification de chaque collège
    for (const college of this.papValues.colleges) {
      if (!college.collegeType || college.collegeType.length === 0) return false;
      if (!college.collegeName) return false;
      if (!college.genderDistribution || college.genderDistribution.every(v => v === 0)) return false;
      if (college.seats <= 0 && college.substituteSeats <= 0) return false;
      if (college.lineup <= 0) return false;
      if (!college.composition || college.composition.length === 0) return false;
      if (!college.proportion || college.proportion.every(v => v === 0)) return false;
    }

    return true;
  }

  secondStepCompleted(): boolean {
    if (!this.currentPoll.description?.trim()) return false;
    if (!this.currentPoll.title?.trim()) return false;
    if (this.currentPoll.hasPassword === true && !this.currentPoll.password?.trim()) return false;
    return true;
  }

  get validatedCategoriesCount(): number {
    return this.verifiedComponents.filter(component => component === true).length;
  }

  get validatedCerfaCategoriesCount(): number {
    return this.cerfaVerifiedComponents.filter(component => component === true).length;
  }

  backToPapVerification() {
    this.papVerificationStep = true
    this.papCompletedStep = false;
    this.updateCurrentStep();
  }

  backToCerfaVerification() {
    this.cerfaCreationStep = true
    this.papCreationStep = false
    this.papCompletedStep = false;
    this.cerfaCompletedStep = false;
    this.cerfaVerificationStep = false;
    this.cerfaComponentValidated = false;
    this.cerfaVerificationPercentage = 0;
    this.cerfaExpandedView = [true, false, false, false, false];
    this.cerfaVerifiedComponents = [false, false, false, false, false];
    this.pollCreationStep = false;
    this.updateCurrentStep();
  }

  goToCerfaCreation() {
    this.cerfaCreationStep = true
    this.papCreationStep = false
    this.papCompletedStep = false;
    this.cerfaVerificationStep = false;
    this.cerfaCompletedStep = false;
    this.cerfaComponentValidated = false;
    this.cerfaVerificationPercentage = 0;
    this.cerfaExpandedView = [true, false, false, false, false];
    this.cerfaVerifiedComponents = [false, false, false, false, false];
    this.pollCreationStep = false;
    this.updateCurrentStep();
  }

  initAssessorsLaunch() {
    this.assessorsInvitesLoader = true;
    this.apiService.initAssessorMails(this.currentPoll.id).subscribe(
      res => {
        this.testStepStatus = 'AssessorTest';
        this.assessorsInvitesLoader = false;
      },
      err => {
        this.assessorsInvitesLoader = false;
      }
    );
  }

  initAssessorsVote() {
    this.apiService.initAssessorVote(this.currentPoll.id).subscribe(res => {
      this.isTestVoteOpen = true;
    });
  }

  validateTestVote(event: boolean) {
    if (event) {
      this.apiService.validateAssessorVote(this.currentPoll.id).subscribe(res => {
        this.testStepStatus = 'AssessorTestValidated'
      });
    } else {
      this.apiService.restartAssessorVote(this.currentPoll.id).subscribe(res => {
        this.assessorStep = 1;
      });
    }
  }


  closeAssessorsVote() {
    this.closingAssessorsVoteLoader = true;
    this.apiService.closeAssessorVote(this.currentPoll.id).subscribe(
      res => {
        this.unsealStepReady = true;
        this.closingAssessorsVoteLoader = false;
      },
      err => {
        this.closingAssessorsVoteLoader = false;
      }
    );
  }

  goToPapCreation() {
    this.cerfaCreationStep = false
    this.papCreationStep = true
    this.papCompletedStep = false;
    this.cerfaVerificationStep = false;
    this.cerfaCompletedStep = false;
    this.cerfaComponentValidated = false;
    this.cerfaVerificationPercentage = 0;
    this.cerfaExpandedView = [true, false, false, false, false];
    this.cerfaVerifiedComponents = [false, false, false, false, false];
    this.pollCreationStep = false;
    this.updateCurrentStep();
  }

  goToPollCreation() {
    this.cerfaCreationStep = false
    this.papCreationStep = false
    this.papCompletedStep = false;
    this.cerfaVerificationStep = false;
    this.cerfaCompletedStep = false;
    this.cerfaComponentValidated = false;
    this.cerfaVerificationPercentage = 0;
    this.cerfaExpandedView = [false, false, false, false, false];
    this.cerfaVerifiedComponents = [false, false, false, false, false];
    this.pollCreationStep = true;
    this.step = 1
    this.updateCurrentStep();
    this.stepOneDone = this.firstStepCompleted()
  }

  onCerfaValidatedComponentsChange($event: number) {
    this.cerfaVerifiedComponents[$event] = true;
    this.cerfaComponentValidated = this.cerfaVerifiedComponents.every(component => component === true);
    const validatedCount = this.cerfaVerifiedComponents.filter(component => component === true).length;
    this.cerfaVerificationPercentage = Math.round((validatedCount / this.cerfaVerifiedComponents.length) * 100);
    const firstFalseIndex = this.cerfaVerifiedComponents.findIndex(component => component === false);

    if (firstFalseIndex !== -1) {
      this.cerfaExpandedView = this.cerfaExpandedView.map(() => false);
      this.cerfaExpandedView[firstFalseIndex] = true;

      setTimeout(() => {
        const sectionIds = [
          'information-verif',
          'length-verif',
          'list-verif',
          'sirets-verif',
          'contact-verif'
        ];
        const element = document.getElementById(sectionIds[firstFalseIndex]);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }

  onValidatedComponentsChange($event: number) {
    this.verifiedComponents[$event] = true;
    this.componentValidated = this.verifiedComponents.every(component => component === true);

    // Calculer le pourcentage d'éléments validés
    const validatedCount = this.verifiedComponents.filter(component => component === true).length;
    this.verificationPercentage = Math.round((validatedCount / this.verifiedComponents.length) * 100);

    // Trouver le premier index où la valeur est false
    const firstFalseIndex = this.verifiedComponents.findIndex(component => component === false);

    // Si un index est trouvé, définir expandedView à cet index à true
    if (firstFalseIndex !== -1) {
      // Réinitialiser tous les expandedView à false
      this.expandedView = this.expandedView.map(() => false);
      // Définir expandedView à l'index trouvé à true
      this.expandedView[firstFalseIndex] = true;

      // Scroller vers la section correspondante
      setTimeout(() => {
        const sectionIds = [
          'information-verif',
          'employer-verif',
          'union-verif',
          'length-verif',
          'period-verif',
          'headcount-verif',
          'college-verif',
          'application-verif',
          'year-verif'
        ];
        const element = document.getElementById(sectionIds[firstFalseIndex]);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }

  isVenueCompleted(): boolean {
    const venue = this.papValues.venue;

    // Vérifier que tous les champs sont remplis
    if (!venue.legalName || !venue.legalForm || !venue.capital ||
      !venue.rcs || !venue.address || !venue.siret ||
      !venue.zipcode || !venue.city) {
      return false;
    }

    // Vérifier que capital est numérique
    if (isNaN(Number(venue.capital))) {
      return false;
    }

    // Vérifier que siret est numérique et fait maximum 14 caractères
    if (isNaN(Number(venue.siret)) || venue.siret.length != 14) {
      return false;
    }

    return true;
  }

  isEmployerCompleted(): boolean {
    const employer = this.papValues.employer;
    return !!(employer.name && employer.firstName && employer.role);
  }

  isTermCompleted(): boolean {
    const term = this.papValues.termLength;
    return !!(term.duration && term.duration.length === 2 && (term.duration[0] > 0 || term.duration[1] > 0));
  }

  isPeriodCompleted(): boolean {
    const period = this.papValues.period;
    return !!(period.fROpening && period.fRClosing && period.sROpening && period.sRClosing);
  }

  isHeadcountCompleted(): boolean {
    const headcount = this.papValues.headcount;
    if (headcount.fullMembers > headcount.total) {
      return false;
    }
    if (headcount.total == 0 || headcount.fullMembers == 0) {
      return false;
    }
    return !!(headcount.total && headcount.fullMembers && headcount.numberOfColleges);
  }

  isCollegesCompleted(): boolean {
    const colleges = this.papValues.colleges;

    const totalLineup = this.papValues.colleges.reduce((sum, college) => sum + (college.lineup || 0), 0);

    if (totalLineup > this.papValues.headcount.total) {
      // console.log("false due to lineup");

      return false;
    }
    for (const college of colleges) {
      if (!college.collegeType || college.collegeType.length !== 1 || !college.collegeType[0]) {
        // console.log("false due to collegeType");
        return false;
      }

      if (!college.collegeName) {
        // console.log("false due to collegeName");
        return false;
      }

      if (college.seats <= 0 || college.lineup <= 0) {
        // console.log("false due to seats or lineup");
        return false;
      }

      const headcount = this.papValues.headcount;
      const totalSeats = this.papValues.colleges.reduce((sum, college) => sum + (college.seats || 0), 0);
      const totalSubstituteSeats = this.papValues.colleges.reduce((sum, college) => sum + (college.substituteSeats || 0), 0);
      if (totalSeats != headcount.fullMembers || totalSubstituteSeats > headcount.fullMembers) {
        // console.log("false due to seats vs fullMembers");
        return false;
      }

      if (!college.composition || college.composition.length < 1) {
        // console.log("false due to composition");
        return false;
      }

      if (college.composition.includes(LineupOptions.Other) && !college.detail) {
        // console.log("false due to detail");
        return false;
      }

      if (!college.proportion || college.proportion.every(val => val === 0)) {
        // console.log("false due to proportion");
        return false;
      }
    }

    return true;
  }

  isApplicationCompleted(): boolean {
    const app = this.papValues.application;

    // Au moins une option doit être activée
    if (!app.mailOption && !app.emailOption && !app.handOption) {
      return false;
    }

    // Si handOption est activée, vérifier firstName et lastName
    if (app.handOption) {
      if (!app.firstName || app.firstName.length === 0 || !app.lastName || app.lastName.length === 0) {
        return false;
      }
    }

    // Si mailOption est activée, vérifier address, zip et city
    if (app.mailOption) {
      if (!app.address || app.address.length === 0 || !app.zip || app.zip.length === 0 || !app.city || app.city.length === 0) {
        return false;
      }
    }

    // Si emailOption est activée, vérifier emailAddress et son format
    if (app.emailOption) {
      if (!app.emailAddress || app.emailAddress.length === 0) {
        return false;
      }
      // Vérifier le format de l'email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(app.emailAddress)) {
        return false;
      }
    }

    // Vérifier que les dates limites sont définies
    if (!app.firstRoundLimit || !app.secondRoundLimit) {
      return false;
    }

    return true;
  }

  stepCompleted(newValue: PAP) {
    console.log(newValue);


    this.papValues = newValue;
    this.stepOneDone = this.firstStepCompleted();
    this.stepTwoDone = this.secondStepCompleted();
  }

  onPapValuesChange(newValue: PAP) {


    this.papValues = newValue;
    this.isCollegesCompleted()
    if (this.isVenueCompleted() &&
      this.isEmployerCompleted() &&
      this.isTermCompleted() &&
      this.isPeriodCompleted() &&
      this.isHeadcountCompleted() &&
      this.isCollegesCompleted() &&
      this.isApplicationCompleted()) {
      this.papVerificationReady = true;
    } else {
      this.papVerificationReady = false;
    }
  }

  isCerfaInformationCompleted(): boolean {
    const venue = this.papValues.venue;

    if (!venue.legalName || !venue.address || !venue.siret ||
      !venue.zipcode || !venue.city || !venue.idcc) {
      return false;
    }
    if (isNaN(Number(venue.idcc)) || venue.idcc.length !== 4) {
      return false;
    }
    if (isNaN(Number(venue.siret)) || venue.siret.length !== 14) {
      return false;
    }

    return true;
  }

  isLengthCompleted(): boolean {
    const term = this.papValues.termLength;
    const headcount = this.papValues.headcount;

    // Vérifier que les deux durées ne sont pas à 0
    if (term.duration[0] === 0 && term.duration[1] === 0) {
      return false;
    }

    // Vérifier que numberOfColleges est entre 1 et 4
    if (headcount.numberOfColleges < 1 || headcount.numberOfColleges > 4) {
      return false;
    }

    return true;
  }

  isSiretsCompleted(): boolean {
    const sirets = this.papValues.sirets.sirets;;

    for (const siret of sirets) {
      if (siret.length !== 0 && siret.length !== 14) {
        return false;
      }
    }

    return true;
  }

  isContactCompleted(): boolean {
    const contact = this.papValues.contact;

    if (!contact.name || !contact.firstName || !contact.occupation || !contact.phone || !contact.mail) {
      return false;
    }

    if (!/^\d{10}$/.test(contact.phone)) {
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(contact.mail)) {
      return false;
    }

    return true;
  }

  onCerfaValuesChange(newValue: PAP) {
    if (
      this.isCerfaInformationCompleted() &&
      this.isLengthCompleted() &&
      this.isContactCompleted() &&
      this.isSiretsCompleted()) {
      this.cerfaVerificationReady = true;
    } else {
      this.cerfaVerificationReady = false;
    }
  }

  updateColleges() {
    const targetCount = this.papValues.headcount.numberOfColleges;
    const currentCount = this.papValues.colleges.length;

    if (targetCount > currentCount) {
      for (let i = currentCount; i < targetCount; i++) {
        this.papValues.colleges.push({
          collegeType: [],
          collegeName: '',
          genderDistribution: [0, 0],
          seats: 0,
          lineup: 0,
          substituteSeats: 0,
          composition: [],
          proportion: [0, 0],
          substituteProportion: [0, 0],
          detail: '',
          cancelledElection: new Date()
        });
      }
    } else if (targetCount < currentCount) {
      this.papValues.colleges = this.papValues.colleges.slice(0, targetCount);
    }
  }

  goToVerification() {
    this.papCreationStep = false;
    this.papVerificationStep = true;

    // Pour reset l'ecran de vérification. Idéalement tout ça devrait être dans un state manager
    this.expandedView = [true, false, false, false, false, false, false, false, false];
    this.verifiedComponents = [false, false, false, false, false, false, false, false, false];
    this.verificationPercentage = 0;
    this.updateCurrentStep();
  }

  onEditRequested(anchorId: string) {
    this.papVerificationStep = false;
    this.papCreationStep = true;
    this.updateCurrentStep();
    setTimeout(() => {
      const element = document.getElementById(anchorId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  }

  onCerfaEditRequested(anchorId: string) {
    this.cerfaVerificationStep = false;
    this.cerfaCreationStep = true;
    this.updateCurrentStep();
    setTimeout(() => {
      const element = document.getElementById(anchorId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  }

  isClientAssoc() {
    if (this.clientType !== null) { this.isAssoc = this.clientType !== 'corp'; }
    else { this.isAssoc = true; }
  }

  displaySMSOption($event: number) {
    this.isClientAssoc();
    this.selectedOffer = $event;
    this.smsAdditionalOption = true;
  }

  newPoll() {
    this.router.navigate(['/poll-creation']);
  }

  prePoll() {
    if (this.prePolToast)
      this.prePolToast = false;
    else
      this.prePolToast = true;
  }

  openPapPopup() {
    this.papPopup = true;
  }

  closePapPopup() {
    this.papPopup = false;
  }

  buyCredits() {
    this.shouldBuyCredits = true;
  }

  seeVideos() {
    window.open('https://www.v8te.com/fr/tutoriels', '_blank');
  }

  goToProfile() {
    this.router.navigate(['/profile']);
  }

  downloadDocuments() {
    window.open('https://drive.google.com/drive/folders/1sP4ShTvOKcAU0fkFeNoibJCLao-pZfQC?usp=sharing', '_blank');
  }

  downloadGuide() {
    switch (this.language) {
      case 'fr': { window.open('https://medium.com/fr-guides-v8te', '_blank'); return; }
      case 'es': { window.open('https://medium.com/es-gu%C3%ADas-v8te', '_blank'); return; }
      default: { window.open('https://medium.com/en-v8te-guides', '_blank'); return; }
    }

  }

  contactMail() {
    const mailText = 'mailto:support_client@v8te.com';
    window.open(mailText);
  }

  confirmPap() {
    this.apiService.savePapData(this.papValues).subscribe(res => {
      const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\n' });
      saveAs(blob, 'pap.docx');
    });
    this.papCreationStep = false;
    this.papVerificationStep = false;
    this.papCompletedStep = true;

    this.cerfaCreationStep = false;
    this.cerfaCompletedStep = false;
    this.cerfaVerificationStep = false;
    this.updateCurrentStep();
  }

  confirmCerfa() {
    this.cerfaCreationStep = false;
    this.cerfaCompletedStep = true;
    this.cerfaVerificationStep = false;
    this.papValues.draftId = this.currentPoll.id;
    this.apiService.saveCseData(this.papValues).subscribe(res => {
      this.updateCurrentStep();
    });
  }

  goToCerfaVerification() {
    this.cerfaCreationStep = false;
    this.cerfaVerificationStep = true;
    this.cerfaCompletedStep = false;
    this.updateCurrentStep();
  }

  dismissInitialPopup() {
    this.hotlinePopup = false;
    this.confirmContact = false;
    this.getContacted = false;
    this.moreOption = false;
    this.smsAdditionalOption = false;
    this.shouldDisplayPopup = false;
    this.shoulDisplayChangePopup = false;
    this.editionDonePopup = false;
    this.displayHotline = false;
    this.hotlineConfirmation = false;
    this.getContacted = false;
    this.confirmContact = false;
  }

  dismissPayPopup($event: boolean) {
    if ($event === false) { this.isClientAssoc(); }
    this.shouldBuyCredits = false;
  }

  logout() {
    this.auth.logout();
    this.router.navigate(['/connexion']);
  }

  cancelNewLicencesPopup() {
    this.hotlineConfirmation = false;
    this.shouldDisplayNewLicences = false;
  }

  changeSubscription() {
    this.shoulDisplayChangePopup = true;
    this.smsAdditionalOption = true;
  }

  dismissChangePopup() {
    window.location.reload();
  }

  getContactPhone($event: string) {
    const mailData = this.licenseService.getContactMailObject(this.selectedOffer, this.accountName, this.isAssoc, $event);
    this.auth.sendContactMail(mailData).subscribe((res) => {
      this.confirmContact = true;
      this.getContacted = false;
    });
  }

  openOffers($event) {
    if ($event) { this.getContacted = true; }
    else {
      this.shouldBuyCredits = true;
    }
    this.moreOption = false;
  }

  displayMoreInfo($event) {
    this.moreOption = true;
    this.selectedOffer = $event[0];
    this.isAssoc = $event[1] === 1;
  }

  setSMSOption($event: number) {
    this.licenseService.setSMSOption($event, this.selectedOffer, this.isAssoc, this.dismissChangePopup);
  }

  triggerHotlinePopup() {
    this.hotlinePopup = true;
  }

  closeChangeMailAssessorPopup($event: boolean) {
    this.displayChangeAssessor = false
    if ($event === true) {
      this.getPollData()
    }
  }

  initData() {
    this.licenseService.license.subscribe((res: LicenseData) => {
      if (res != null) {
        this.remainingLicense = res.events;
        this.licencesReady = true;
        this.maxVoters = res.votes;
        this.hasHotline = res.hasHotline;
        if (res.hasSMS === true) { this.sms = '- ' + res.sms + ' SMS'; }
        else { this.sms = ''; }
        this.clientType = res.client;
        if (res.client !== null) { this.isAssoc = res.client !== 'corp'; }
        this.licenseTime = this.common.licenseResponseGetTime(res);
        this.hasSmsVoters = res.sms > 5;
      }
      this.auth.currentUser.subscribe((usr) => {
        this.accountName = this.auth.getUserData();
      });
    });
    this.licenseService.refreshLicense();
    // this.apiService.getPolls(this.common.getLangCode()).subscribe((res: PollDashboardResponse) => {
    //   this.route.queryParams.subscribe((params) => {
    //     if (params.session_id === undefined) {
    //       this.shouldDisplayPopup = res.finished.length === 0 && res.ongoing.length === 0 && res.planned.length === 0;
    //     }
    //   });
    // });
    this.route.queryParams.subscribe((params) => {
      if (params.session_id != null) {
        this.apiService
          .getSubscriptionData(params.session_id)
          .subscribe((res: Array<SubsciptionData>) => {
            if (res.length > 0 && res[0].type === 'H') { this.hotlineConfirmation = true; }
            else { this.shouldDisplayNewLicences = true; }
            this.newLicences = res;
          });
      }
      if (params.draft != null) {
        this.apiService.getDraft(params.draft, false).subscribe((res: ReceivedDraft) => {
          const draftPoll: Poll = JSON.parse(res.data);
          this.currentPoll = this.createWatchedPoll(draftPoll);
          if (res.papValues != null) {
            this.papValues = JSON.parse(res.papValues);
          }
          if (res.published) {
            this.papCreationStep = false;
            this.currentStep = 4;
            this.assessorClosingStep = true;
            this.apiService.getPoll(params.draft).subscribe((res: ReceivedPoll) => {
              console.log(res);
              this.pollId = res.uuid;
              this.currentPoll.rounds = res.rounds;
              //console.log(this.currentPoll);
              this.currentPoll.assessors = res.assessorObjects;
              if (res.pollPlanningStatus === 'AssessorTesting' || res.pollPlanningStatus === 'AssessorTestValidated' || res.pollPlanningStatus === 'AssessorTestCompleted') {
                this.isTestVoteOpen = true;
              }
              if (res.pollPlanningStatus === 'AssessorTestValidated' || res.pollPlanningStatus === 'AssessorTestCompleted') {
                this.assessorStep = 2;
              }
              if (res.pollPlanningStatus === 'Validated') {
                this.testStepStatus = 'Validated';
                this.assessorClosingStep = false;
                this.pollReadyStep = true;
                this.currentStep = 5;
              }

              this.testStepStatus = res.pollPlanningStatus;
              this.assessorTestQuorum = res.assessorTest;
              this.apiService.getInactiveAssessors(params.draft).subscribe((res: Array<string>) => {
                this.inactiveAssessors = res.map(x => ShortVoter.withEmail(x.split(' - ')[1]));


                // if (this.inactiveAssessors != undefined) {
                this.remainingAssessors = res.length;
                // }
              });

              this.apiService.getNonClosingAssessors(params.draft).subscribe((res: Array<AssessorData>) => {
                //  console.log(res);
                this.unsealedAssessors = res
                this.isBallotUnsealed = Math.ceil(this.currentPoll.assessors.length / 2) <= this.currentPoll.assessors.length - this.unsealedAssessors.length;

              },);

            });
          }
        });
      }
    });
  }

  getPollData() {
    this.apiService.getPoll(this.pollId).subscribe((res: ReceivedPoll) => {
      console.log(res);
      this.pollId = res.uuid;
      this.currentPoll.rounds = res.rounds;
      //console.log(this.currentPoll);
      this.currentPoll.assessors = res.assessorObjects;
      if (res.pollPlanningStatus === 'AssessorTesting' || res.pollPlanningStatus === 'AssessorTestValidated' || res.pollPlanningStatus === 'AssessorTestCompleted') {
        this.isTestVoteOpen = true;
      }
      if (res.pollPlanningStatus === 'AssessorTestValidated' || res.pollPlanningStatus === 'AssessorTestCompleted') {
        this.assessorStep = 2;
      }
      if (res.pollPlanningStatus === 'Validated') {
        this.testStepStatus = 'Validated';
        this.assessorClosingStep = false;
        this.pollReadyStep = true;
        this.currentStep = 5;
      }

      this.testStepStatus = res.pollPlanningStatus;
      this.assessorTestQuorum = res.assessorTest;
      this.apiService.getInactiveAssessors(this.pollId).subscribe((res: Array<string>) => {
        this.inactiveAssessors = res.map(x => ShortVoter.withEmail(x.split(' - ')[1]));

        // if (this.inactiveAssessors != undefined) {
        this.remainingAssessors = res.length;
        // }
      });

      this.apiService.getNonClosingAssessors(this.pollId).subscribe((res: Array<AssessorData>) => {
        //  console.log(res);
        this.unsealedAssessors = res
        this.isBallotUnsealed = Math.ceil(this.currentPoll.assessors.length / 2) <= this.currentPoll.assessors.length - this.unsealedAssessors.length;

      },);

    });
  }

  goToLastAssessorStep() {
    if (this.assessorStep === 1) {
      this.assessorStep = 2;
      this.testStepStatus = 'AssessorTestCompleted';
    } else if (this.assessorStep === 2) {
      this.assessorClosingStep = false;
      this.apiService.publishPoll(this.currentPoll.id).subscribe(res => {
        // this.router.navigate(['/poll-planned/' + this.currentPoll.id]);
        this.currentStep = 5;
        this.pollReadyStep = true
      });
    }
  }



  goToPollPlanned() {
    this.router.navigate(['/poll-planned/' + this.currentPoll.id]);
  }

  ngOnInit() {
    if (this.router.url.includes('edited')) {
      this.editionDonePopup = true;
    }
    this.licencesReady = false;
    this.isAssoc = true;
    const languageKey = 'userLanguage';
    const userLang = navigator.language || navigator[languageKey];
    this.language = userLang.substring(0, 2);
    const referral = localStorage.getItem('referral');
    if (referral != null) {
      this.apiService.sendReferral(referral).subscribe((res) => {
        localStorage.removeItem('referral');
        this.initData();
      },
        (err) => {
          //  TO DO: display error
          localStorage.removeItem('referral');
          this.initData();
        }
      );
    } else {
      this.initData();
    }
    this.updateCurrentStep();
  }
}
